import isIBanner from './node/isIBanner';
import isICard from './node/isICard';
import isICarousel from './node/isICarousel';
import isIContainer from './node/isIContainer';
import isILink from './node/isILink';
import isIList from './node/isIList';
import isIModal from './node/isIModal';
import isIPadding from './node/isIPadding';
import isIScrollable from './node/isIScrollable';
import isISpan from './node/isISpan';
export function hasChildren(node) {
    return isIBanner(node) || isICard(node) || isICarousel(node) || isIContainer(node) || isILink(node) || isIList(node) || isIModal(node) || isIPadding(node) || isIScrollable(node) || isISpan(node);
}
export default hasChildren;    //# sourceMappingURL=hasChildren.js.map
